import FullPageLayout from './FullPageLayout';
import './FullPageLayout.css';

export default FullPageLayout;



// WEBPACK FOOTER //
// ./src/components/FullPageLayout/index.js